import { LowerCasePipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '([formControlName], [formControl])[raptorTextTransform]'
})
export class RaptorTextTransformDirective {
  @Input() raptorTextTransform: string | undefined;

  constructor(
    private ngControl: NgControl,
    private lowerCasePipe: LowerCasePipe,
    private titleCasePipe: TitleCasePipe,
    private upperCasePipe: UpperCasePipe
  ) { }

  @HostListener('blur') onBlur() {
    this.textTransform();
  }

  private textTransform() {
    if (
      this.ngControl &&
      this.ngControl.control && 
      this.ngControl.control.value &&
      this.ngControl.control.value !== '' &&
      this.raptorTextTransform &&
      this.raptorTextTransform !== 'none'
    ) {
      let value = this.ngControl.control.value;

      if (this.raptorTextTransform === 'capitalization') {
        value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
      }
      if (this.raptorTextTransform === 'lowercase') {
        value = this.lowerCasePipe.transform(value);
      }
      if (this.raptorTextTransform === 'titlecase') {
        value = this.titleCasePipe.transform(value);
      }
      if (this.raptorTextTransform === 'uppercase') {
        value = this.upperCasePipe.transform(value);
      }

      this.ngControl.control.patchValue(value, { emitEvent: false });
    }
  }
}
